import { OnboardingMultiDocument } from '@blisspointmedia/bpm-types/dist/ClientOracleOnboarding';

// An add carries its file. An edit names its document, and a null file keeps the current one.
export type MultiDocumentFormValues =
  | { doc?: undefined; file: File; note: string }
  | { doc: OnboardingMultiDocument; file: File | null; note: string };

// The add and edit modal's copy for one section.
export interface MultiDocumentModalCopy {
  // Follows "Add" or "Edit" in the title.
  itemTitle: string;
  addLabel: string;
  noteLabel: string;
  noteHelp: string;
}

export interface MultiDocumentTableCopy {
  heading: string;
  itemColumnLabel: string;
  noteColumnLabel: string;
}

export const MultiDocumentLayout = {
  LIST: 'list',
  TABLE: 'table'
} as const;

// How a section shows its documents. A table's intro shows above the card body in every state.
export type MultiDocumentBody =
  | { layout: typeof MultiDocumentLayout.LIST; emptyStateCopy: string }
  | { layout: typeof MultiDocumentLayout.TABLE; intro: string; table: MultiDocumentTableCopy };
